<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { computed, useSlots } from "vue";
import { Markdown } from "vue-stream-markdown";
import "vue-stream-markdown/index.css";
import { cn } from "@/lib/utils";

interface Props {
  content?: string;
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();

const slots = useSlots();
const slotContent = computed<string | undefined>(() => {
  const nodes = slots.default?.();
  if (!Array.isArray(nodes)) {
    return undefined;
  }
  let text = "";
  for (const node of nodes) {
    if (typeof node.children === "string") {
      text += node.children;
    }
  }
  return text || undefined;
});

const md = computed(() => (slotContent.value ?? props.content ?? "") as string);
</script>

<template>
  <Markdown
    mode="static"
    :content="md"
    :class="cn('size-full [&>*:first-child]:mt-0! [&>*:last-child]:mb-0!', props.class)"
    v-bind="$attrs"
  />
</template>
